import PropTypes from 'prop-types'
import {Button, Collapse, Flex, useDisclosure} from '@chakra-ui/react'
import {ChevronDownIcon} from '@chakra-ui/icons'
import {useTranslation} from 'react-i18next'
import {AuthProvider} from '../../../contexts/authentication'
import {useRails} from '../../../contexts/rails'
import FastLinkWrapper from '../../FastLinkWrapper'

const YodleeIntegrationScreen = ({
  onSuccess,
  onFailure,
  onBankNotListed,
  connectedEndpoint,
}) => {
  const {authenticityToken} = useRails()
  const {t} = useTranslation('connectPayoutAccount')
  const {isOpen, onToggle} = useDisclosure()

  return (
    <AuthProvider authenticityToken={authenticityToken}>
      <Flex flexDirection="column">
        <Flex justifyContent="center">
          <FastLinkWrapper
            onSuccess={onSuccess}
            onFailure={onFailure}
            connectedEndpoint={connectedEndpoint}
            my="sm"
          />
        </Flex>
        {/* Pinned so the fallback prompt stays visible however tall Yodlee's
            frame grows, rather than being pushed below the scroll fold. */}
        <Flex
          position="sticky"
          bottom="0"
          bg="mld.neutral.0"
          px="lg"
          py="md"
          flexDirection="column"
          alignItems="flex-start"
        >
          <Button
            variant="link"
            color="mld.neutral.900"
            fontSize="sm"
            aria-expanded={isOpen}
            rightIcon={
              <ChevronDownIcon
                boxSize="1.25em"
                transform={isOpen ? 'rotate(180deg)' : undefined}
                transition="transform 0.2s"
              />
            }
            onClick={onToggle}
          >
            {t('modal.yodlee.havingTrouble')}
          </Button>
          <Collapse in={isOpen} unmountOnExit>
            <Button
              variant="link"
              color="mld.neutral.900"
              fontSize="xs"
              textDecoration="underline"
              mt="xs"
              onClick={onBankNotListed}
            >
              {t('modal.yodlee.completeSetup')}
            </Button>
          </Collapse>
        </Flex>
      </Flex>
    </AuthProvider>
  )
}

YodleeIntegrationScreen.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onFailure: PropTypes.func.isRequired,
  onBankNotListed: PropTypes.func.isRequired,
  connectedEndpoint: PropTypes.string.isRequired,
}

export default YodleeIntegrationScreen
